import { uploadFiles } from "api/uploadApi";
import { t } from "i18next";
import React, { useMemo, useState } from "react";
import { Input, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";

interface UploadFileProps {
    formik: any,
    fieldValue: string,
    isMultiple: boolean,
    acceptFile?: string,
    isUploadMore?: boolean,
    isDisabled?: boolean,
    maxFile?: number,
};

const UploadFile = ({
    formik,
    fieldValue = 'files',
    isMultiple = true,
    acceptFile = "image/jpeg, image/png, image/gif, image/webp, image/svg+xml", // "video/mp4,video/x-m4v,video/*,image/png,image/jpeg,image/*",
    isUploadMore = true,
    isDisabled = false,
}: UploadFileProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const values = useMemo(() => {
        return formik?.values ? formik?.values?.[`${fieldValue}`] : [];
    }, [formik?.values, fieldValue]);

    const handleChangeFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true)
        try {
            const files = event.target.files;
            if (files && files.length > 0) {
                const fileArray = Array.from(files);
                const resUpload = await uploadFiles(files);
                if(resUpload?.data) {
                    formik && formik.setFieldValue(`${fieldValue}`, [...(values || []), ...resUpload?.data]);
                }
                // formik && formik.setFieldValue(`${fieldValue}`, [...(values || []), ...fileArray]);
            }
        }catch (error) {
            toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }finally {
            setIsLoading(false)
        }
        
    };

    const handleDeleteFile = (index: number) => {
        if (isDisabled) {
            return;
        }
        const fileArray = values?.filter((f: any, i: number) => i !== index);
        formik && formik.setFieldValue(`${fieldValue}`, fileArray);
    }

    return (
        <React.Fragment>
            <>
                <div className="d-flex gap-3 flex-wrap position-relative">
                    {(values?.length > 0) && values?.map((_value: any, index: number) => (
                        <div className="position-relative" key={index} style={{ width: '200px', height: '200px', backgroundColor: '#eaeaea', overflow: 'hidden', borderRadius: 'var(--vz-border-radius)' }}>
                            <img
                                // src={_value?.fullPath ? _value?.fullPath : (_value ? URL.createObjectURL(_value) : '')}
                                src={_value?.fullPath ? _value?.fullPath : ''}
                                alt={`preview-${index + 1}`}
                                style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                            />
                            <button type="button" className="position-absolute btn btn-sm btn-soft-danger edit-item-btn"
                                style={{
                                    top: '10px',
                                    right: '10px',
                                    width: '30px',
                                    height: '30px',
                                    borderRadius: '15px',
                                }}
                                onClick={() => handleDeleteFile(index)}
                            ><i className="ri-delete-bin-3-fill align-bottom"></i></button>
                        </div>
                    ))}
                    {
                        isLoading && (
                            <Spinner size="sm" className="me-2 text-primary" style={{position: "absolute", top: "47%", left: "47%", zIndex: 2}}></Spinner>
                        )
                    }
                    {(!!isUploadMore) && <div className={`custom-file-image-button`}>
                        <Input
                            className="form-control"
                            accept={acceptFile}
                            label="Upload Your Image"
                            data-title="Upload Your Image"
                            id="formSizeDefault"
                            type="file"
                            multiple={isMultiple}
                            disabled={isDisabled}
                            onChange={handleChangeFile}
                        />
                        {<div className="text-upload" style={{ zIndex: 1 }}>  <i className="ri-upload-line me-2" /> {values?.length ? t('Add Image') : t('No file chosen')}</div>}
                    </div>}
                </div>
            </>
        </React.Fragment>
    );
};

export default UploadFile;
